export default __webpack_public_path__ + "static/media/login-company-logos.606cfb06.png";